import { Component } from "react";
import enhanceWithClickOutside from "react-click-outside";
import TextField from "basicComponents/TextField/TextField";
import * as PropTypes from "prop-types";

class AutosaveTextField extends Component {
  state = {};

  handleClickOutside() {
    this.props.onConfirm();
  }

  render() {
    return <TextField {...this.props} />;
  }
}

AutosaveTextField.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  ...TextField.propTypes,
};

export default enhanceWithClickOutside(AutosaveTextField);
